import { TransferTimes } from 'mmfintech-backend-api'
import type { PaymentOptionResponse, TransferTime } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'

// Insurance defaults — only used if the backend localization key isn't loaded in the translations.
const TRANSFER_TIME_DEFAULTS: Record<TransferTime, string> = {
  [TransferTimes.INSTANT]: 'Instant',
  [TransferTimes.SAME_DAY]: 'Same day',
  [TransferTimes.ONE_TO_FIVE_DAYS]: '1–5 business days'
}

// Driven by the backend `localizationKey` (admin-managed copy); the enum default is the safety net.
export function resolveTransferTimeLabel(method: PaymentOptionResponse | undefined): string {
  const { transferTime, localizationKey } = method?.paymentMethodDescription ?? {}
  return !localizationKey ? '' : tr(localizationKey, transferTime ? TRANSFER_TIME_DEFAULTS[transferTime] : '')
}
